import { api } from "..";

export function updateSettingsRequest({ data }) {
  return api.put(`/v1/settings`, data);
}

export function getSettingsRequest({ params }) {
  return api.get(`/v1/settings`, {
    params,
  });
}
